import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';
export const AsyncAdvertiseRequestServiceDeskFooter = withAsync({
    loader: lazyForPaint(() =>
        import(/* webpackChunkName: 'request-service-desk-cta' */ './hocs').then(({ default: footerCTA }) => footerCTA)
    ),
    LoadingSkeleton: () => <></>,
});
